"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* eslint-disable global-require */
var _default = exports["default"] = {
  framerate: 24,
  images: [require('./cornerSprite.png')],
  frames: [[887, 292, 291, 286, 0, 71, 2], [2, 872, 291, 286, 0, 71, 2], [1477, 582, 291, 286, 0, 71, 2], [1182, 582, 291, 286, 0, 71, 2], [887, 582, 291, 286, 0, 71, 2], [592, 582, 291, 286, 0, 71, 2], [297, 582, 291, 286, 0, 71, 2], [2, 582, 291, 286, 0, 71, 2], [1477, 292, 291, 286, 0, 71, 2], [1182, 292, 291, 286, 0, 71, 2], [297, 872, 291, 286, 0, 71, 2], [592, 292, 291, 286, 0, 71, 2], [297, 292, 291, 286, 0, 71, 2], [2, 292, 291, 286, 0, 71, 2], [1477, 2, 291, 286, 0, 71, 2], [1182, 2, 291, 286, 0, 71, 2], [887, 2, 291, 286, 0, 71, 2], [592, 2, 291, 286, 0, 71, 2], [297, 2, 291, 286, 0, 71, 2], [2, 2, 291, 286, 0, 71, 2]],
  animations: {
    'speech loop': {
      frames: [1, 1, 1, 2, 2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 7, 8, 8, 8, 9, 9, 9, 1, 1, 1, 7, 7, 7, 4, 4, 4, 3, 3, 3, 10, 10, 11, 12, 13, 13, 1, 1, 1, 14, 14, 14, 15, 15, 15, 1, 1, 1, 3, 3, 4, 4, 4, 16, 16, 16, 17, 17, 17, 18, 18, 18, 3, 3, 3, 19, 19, 19, 0, 0, 0],
      speed: 1
    },
    still: {
      frames: [0, 0, 0],
      speed: 1
    }
  }
};